/**
 * Engagement level helper.
 * Returns { label, color, bg } based on percentage and display mode.
 */
export function getEngagementDisplay(pct, mode = 'niveis') {
  const level = pct <= 20 ? { label: 'Baixo', color: '#EF4444', bg: 'bg-red-50 text-red-600' }
    : pct <= 60 ? { label: 'Médio', color: '#F59E0B', bg: 'bg-amber-50 text-amber-600' }
    : { label: 'Alto', color: '#10B981', bg: 'bg-green-50 text-green-600' };

  if (mode === 'percentual') {
    return { label: `${pct}%`, color: level.color, bg: level.bg, isPercent: true };
  }
  return { ...level, pct, isPercent: false };
}
